(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fu-electric-brand-nav"]) return;
  try {
    
  if (!customElements.get('fu-electric-brand-nav')) {
    customElements.define('fu-electric-brand-nav', class extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.closest('.shopify-section');
        this.abort = new AbortController();
        this.frame = 0;
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        const options = { passive: true, signal: this.abort.signal };
        window.addEventListener('scroll', this.schedule, options);
        window.addEventListener('resize', this.schedule, options);
        const cancelAnchorAlignment = () => { this.pendingAnchor = null; };
        ['wheel', 'touchstart', 'pointerdown', 'keydown', 'popstate'].forEach(type => {
          window.addEventListener(type, cancelAnchorAlignment, options);
        });
        document.addEventListener('DOMContentLoaded', this.schedule, { once: true, signal: this.abort.signal });
        this.addEventListener('click', event => {
          const link = event.target.closest('.fu-electric-nav__pill');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          this.pendingAnchor = target;
          if (window.location.hash !== link.hash) history.pushState(null, '', link.hash);
          this.update();
          target.scrollIntoView({ behavior: 'instant', block: 'start' });
          // The site header changes height when it becomes sticky. Re-measure
          // after that layout change so the brand heading remains uncovered.
          requestAnimationFrame(() => {
            this.update();
            target.scrollIntoView({ behavior: 'instant', block: 'start' });
            requestAnimationFrame(() => {
              this.update();
              target.scrollIntoView({ behavior: 'instant', block: 'start' });
            });
          });
        }, { signal: this.abort.signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this);
        document.querySelectorAll('header').forEach(header => this.resizeObserver.observe(header));
        // Images and fonts can finish loading after an anchor jump. Keep that
        // destination clear of the sticky bars until the visitor acts again.
        this.layoutObserver = new ResizeObserver(() => {
          if (!this.pendingAnchor) return;
          this.update();
          this.pendingAnchor.scrollIntoView({ behavior: 'instant', block: 'start' });
        });
        document.querySelectorAll('.fu-electric-showcase, header').forEach(element => this.layoutObserver.observe(element));
        this.schedule();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.layoutObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      update() {
        if (!this.wrapper) return;
        let headerBottom = 0;
        document.querySelectorAll('header').forEach(header => {
          if (header.closest('main')) return;
          const rect = header.getBoundingClientRect();
          if (rect.height > 0 && rect.top <= 100 && rect.bottom > 0 && getComputedStyle(header).visibility !== 'hidden') headerBottom = Math.max(headerBottom, rect.bottom);
        });
        this.wrapper.style.setProperty('--fu-electric-nav-top', Math.ceil(headerBottom) + 'px');
        const sticky = getComputedStyle(this.wrapper).position === 'sticky';
        const offset = headerBottom + (sticky ? this.offsetHeight : 0) + 24;
        let active = null;
        const links = Array.from(this.querySelectorAll('.fu-electric-nav__pill'));
        links.forEach(link => {
          const target = document.getElementById(link.hash.slice(1));
          if (!target) return;
          target.style.scrollMarginTop = Math.ceil(offset) + 'px';
          if (target.getBoundingClientRect().top <= offset + 48) active = link;
        });
        links.forEach(link => {
          if (link === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
